import { useEffect } from 'react';
import { BRAND_ASSETS } from '../data/brand';
interface LinkSpec {
  rel: string;
  href: string;
  type?: string;
  sizes?: string;
}
const linkSpecs: LinkSpec[] = [{
  rel: 'icon',
  href: BRAND_ASSETS.favicon32,
  type: 'image/png',
  sizes: '32x32'
}, {
  rel: 'shortcut icon',
  href: BRAND_ASSETS.favicon32,
  type: 'image/png'
}, {
  rel: 'apple-touch-icon',
  href: BRAND_ASSETS.appleTouchIcon,
  sizes: '180x180'
}, {
  rel: 'icon',
  href: BRAND_ASSETS.appIcon192,
  type: 'image/png',
  sizes: '192x192'
}, {
  rel: 'icon',
  href: BRAND_ASSETS.siteThumbnail512,
  type: 'image/png',
  sizes: '512x512'
}];
const metaSpecs: {
  key: 'property' | 'name';
  value: string;
  content: string;
}[] = [{
  key: 'property',
  value: 'og:image',
  content: BRAND_ASSETS.ogImage
}, {
  key: 'property',
  value: 'og:image:width',
  content: '1200'
}, {
  key: 'property',
  value: 'og:image:height',
  content: '630'
}, {
  key: 'name',
  value: 'twitter:card',
  content: 'summary_large_image'
}, {
  key: 'name',
  value: 'twitter:image',
  content: BRAND_ASSETS.ogImage
}, {
  key: 'name',
  value: 'theme-color',
  content: '#0B1420'
}];

/**
 * Wires the supplied brand icons and share images into the rendered app head.
 * Title, description, canonical and robots values are owned by usePageMeta and
 * are intentionally left untouched here.
 */
export function BrandHead() {
  useEffect(() => {
    // Remove any default icons so the supplied artwork is authoritative.
    document.head.querySelectorAll('link[rel="icon"]:not([data-rp-brand]), link[rel="shortcut icon"]:not([data-rp-brand]), link[rel="apple-touch-icon"]:not([data-rp-brand])').forEach(node => node.remove());
    linkSpecs.forEach(spec => {
      const selector = `link[data-rp-brand="${spec.rel}-${spec.sizes ?? 'default'}"]`;
      let el = document.head.querySelector<HTMLLinkElement>(selector);
      if (!el) {
        el = document.createElement('link');
        el.setAttribute('data-rp-brand', `${spec.rel}-${spec.sizes ?? 'default'}`);
        document.head.appendChild(el);
      }
      el.setAttribute('rel', spec.rel);
      el.setAttribute('href', spec.href);
      if (spec.type) el.setAttribute('type', spec.type);
      if (spec.sizes) el.setAttribute('sizes', spec.sizes);
    });
    metaSpecs.forEach(spec => {
      const selector = `meta[${spec.key}="${spec.value}"]`;
      let el = document.head.querySelector<HTMLMetaElement>(selector);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(spec.key, spec.value);
        document.head.appendChild(el);
      }
      el.setAttribute('content', spec.content);
    });
  }, []);
  return null;
}